import api from '../../../services/api'

export const getAttendanceProof = (proofOn) => api.get(`/attendance-proofs/${proofOn}`)
export const createAttendanceProof = (payload) => api.post('/attendance-proofs', payload)
export const deleteAttendanceProof = (proofOn) => api.delete(`/attendance-proofs/${proofOn}`)
